

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import nameOfAppReducer from './store/nameSlce';
import savingsReducer from './store/savingsSlice';
import notificationSlice from './store/notificationSlice';
import investPalnReducer from './store/investPlanSlice';
import userDetailsReducer from './store/userDetailsSlice';

const store = configureStore({
  reducer: {
    app_name: nameOfAppReducer ,
    save_ins: savingsReducer,
    notifications: notificationSlice,
    invest_pan: investPalnReducer,
    userDetail: userDetailsReducer
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        <App />
        </Provider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();